// extracted by mini-css-extract-plugin
export default {"sceneGizmo":"sceneGizmo___PbwQy","sceneGizmo_button":"sceneGizmo_button___wFfpo"};